import { TranscriptionIcon } from '@mote/assets/icons'
import { Avatar, Block } from '@mote/ui'
import React from 'react'
import styled, { css } from 'styled-components'
import { Control } from '../../shared/components'
import { useMotePlayer } from '../../shared/contexts/motePlayer.context'
import { moteCardFluidDimensionsAdjuster } from './fluidSizing'
import { MoteCardRichCopyFullTranscriptText } from './MoteCardRichCopyFullTranscriptText'
import { MoteCardRichOptionsMenu } from './MoteCardRichOptionsMenu'
import { MoteCardRichTranslateDropdown } from './MoteCardRichTranslateDropdown'

export function MoteCardRichHeader({
  isCreator,
  transcript,
  createdByAvatar,
  onTranscriptLanguageUpdate
}) {
  const { theme, toggleFullTranscript, showFullTranscript, playerDimensions } =
    useMotePlayer()

  return (
    <Root>
      <AvatarContainer
        tabIndex={-1}
        aria-hidden={true}
        size={moteCardFluidDimensionsAdjuster(36, 36, playerDimensions?.width)}
        showFullTranscript={showFullTranscript}
      >
        <Avatar
          url={createdByAvatar}
          size={moteCardFluidDimensionsAdjuster(
            36,
            24,
            playerDimensions?.width
          )}
        />
      </AvatarContainer>

      <Block layout='horizontal' align='center' justify='center' gap={4}>
        <>
          {showFullTranscript && (
            <MoteCardRichCopyFullTranscriptText transcript={transcript} />
          )}
          {playerDimensions?.width > 290 && (
            <>
              <MoteCardRichTranslateDropdown
                isCreator={isCreator}
                onTranscriptLanguageUpdate={onTranscriptLanguageUpdate}
              />
              <Toggle
                size={36}
                theme={theme?.button}
                aria-label={
                  showFullTranscript
                    ? 'Hide full transcript'
                    : 'Show full transcript'
                }
                tooltipProps={{
                  content: 'Toggle full transcript (c)',
                  direction: 'down-end',
                  distance: 7
                }}
                onClick={toggleFullTranscript}
              >
                <TranscriptionIcon color='currentColor' />
              </Toggle>
            </>
          )}
          {playerDimensions?.width <= 290 && (
            <MoteCardRichOptionsMenu
              isCreator={isCreator}
              onTranscriptLanguageUpdate={onTranscriptLanguageUpdate}
            />
          )}
        </>
      </Block>
    </Root>
  )
}

const Root = styled.div`
  position: absolute;
  padding: 3.5%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  left: 0;
  right: 0;
  z-index: 2;
`

const Toggle = styled(Control)`
  color: ${({ theme }) => theme?.color};

  svg {
    height: 24px;
    width: 24px;
  }

  &:hover,
  &:focus {
    color: ${({ theme }) => theme?.hover?.color};
    background: ${({ theme }) => theme?.hover?.background};
  }

  &:focus {
    box-shadow: 0 0 0 2px rgba(47, 166, 255, 0.6);
  }
`

const AvatarContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
  pointer-events: none;
  outline: none;
  visibility: ${({ showFullTranscript }) =>
    showFullTranscript ? 'visible' : 'hidden'};

  ${({ size }) => css`
    width: ${size}px;
    height: ${size}px;
  `}
`
